import { createReducer } from "reduxsauce";
import Types from "./types";
import { getUnderscoreToCamelcaseText } from "../../../utils/helpers/get-underscore-to-camelcase-text";

export const INITIAL_STATE = {
    carouselStoreData: {},
    isLoading: false,
    error: null,
    isCarouselDataLoaded: false
};

export const fetchCarouselStoreData = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: true
    };
};

export const fetchCarouselStoreDataSuccess = (state = INITIAL_STATE, { data }) => {
    const updatedCarouselData = { ...(state.carouselStoreData || {}) };
    Object.keys(data || {}).forEach(key => {
        const camelCaseKey = getUnderscoreToCamelcaseText(key);
        updatedCarouselData[camelCaseKey] = {
            ...updatedCarouselData[camelCaseKey],
            ...data[key]
        };
    });
    return {
        ...state,
        carouselStoreData: {
            ...state.carouselStoreData,
            ...updatedCarouselData
        },
        error: false,
        isLoading: false,
        isCarouselDataLoaded: true
    };
};

export const fetchCarouselStoreDataFailure = (state = INITIAL_STATE, { error }) => {
    return {
        ...state,
        error,
        isLoading: false
    };
};

export const HANDLERS = {
    [Types.FETCH_CAROUSEL_STORE_INIT]: fetchCarouselStoreData,
    [Types.FETCH_CAROUSEL_STORE_DATA_SUCCESS]: fetchCarouselStoreDataSuccess,
    [Types.FETCH_CAROUSEL_STORE_DATA_FAILURE]: fetchCarouselStoreDataFailure
};

export default createReducer(INITIAL_STATE, HANDLERS);
